/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForLogstash extends models.ServiceAccountCredentialsForBasicAuth {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForLogstash");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForLogstash.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForLogstash>): ServiceAccountCredentialsForLogstash {
        let obj = Object.assign(new ServiceAccountCredentialsForLogstash(), model);
        ServiceAccountCredentialsForLogstash.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForLogstash>): ServiceAccountCredentialsForLogstash {
        if (!model) return null;
        return ServiceAccountCredentialsForLogstash.newInstance(<ServiceAccountCredentialsForLogstash> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForLogstash) {
        if (!obj) return;

        models.ServiceAccountCredentialsForLogstash.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForLogstash): boolean {
        if (models.ServiceAccountCredentialsForBasicAuth.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForLogstash.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Certificate File. This is a required field.
     */
    certificate_file: string;

}
